import React, { useState, useEffect } from 'react';
import { Button, Row, Col, Typography, Drawer } from 'antd';
import { useHistory } from 'react-router-dom';
import { ArrowLeftOutlined, HeartOutlined, SafetyOutlined, BulbOutlined, MenuOutlined } from '@ant-design/icons';
import '../../styles/mobile.css';
import { trackWellnessPageView } from '../../utils/analytics';
import meditateCalmiImage from '../../assets/images/meditate_calmi.png';
import unicornImage from '../../assets/images/Classic Unicorn.png';
import lionImage from '../../assets/images/Classic Lion.png';
import squishyBearImage from '../../assets/images/Squish Bear.png';
import squishyUnicornImage from '../../assets/images/Squish Unicorn.png';

const { Title, Text, Paragraph } = Typography;

const CalmiWellness = () => {
  const history = useHistory();
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

  useEffect(() => {
    trackWellnessPageView('wellness');
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#fff', position: 'relative' }}>
      {/* Add CSS animation */}
      <style>
        {`
          @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(var(--rotation)); }
            50% { transform: translateY(-8px) rotate(var(--rotation)); }
          }
          .floating-calmi {
            animation: float 3s ease-in-out infinite;
            cursor: pointer;
            transition: transform 0.3s ease;
          }
          .floating-calmi:hover {
            transform: scale(1.1) rotate(var(--rotation)) !important;
          }
        `}
      </style>

      {/* Header */}
      <div style={{ 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '20px 0',
        marginBottom: '0',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <Button 
            type="text" 
            icon={<ArrowLeftOutlined />} 
            onClick={() => history.push('/')}
            style={{ color: 'white', marginBottom: '10px' }}
          >
            Back to Lumi Bears
          </Button>
          {/* Mobile Layout */}
          <div style={{ display: 'block' }}>
            {/* Top row with logo and menu button */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '10px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
                <span style={{ fontSize: '32px', marginRight: '15px', flexShrink: 0 }}>🌱</span>
                <div>
                  <Title level={2} style={{ color: 'white', margin: 0, fontSize: '20px' }}>
                    How We Help
                  </Title>
                  <Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: '14px' }}>
                    Supporting children through their biggest challenges
                  </Text>
                </div>
              </div>
              
              {/* Desktop navigation - hidden on mobile */}
              <div className="desktop-nav" style={{ 
                gap: '8px', 
                alignItems: 'center'
              }}>
                <Button
                  onClick={() => history.push('/')}
                  style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    color: 'white',
                    borderColor: 'rgba(255, 255, 255, 0.3)',
                    borderRadius: '20px',
                    height: '36px',
                    fontSize: '14px',
                    fontWeight: '500',
                    padding: '0 16px'
                  }}
                >
                  Find Your Companion
                </Button>
                <Button
                  onClick={() => history.push('/platform')}
                  style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    color: 'white',
                    borderColor: 'rgba(255, 255, 255, 0.3)',
                    borderRadius: '20px',
                    height: '36px',
                    fontSize: '14px',
                    fontWeight: '500',
                    padding: '0 16px'
                  }}
                >
                  Safety
                </Button>
                <Button
                  onClick={() => history.push('/blog')}
                  style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    color: 'white',
                    borderColor: 'rgba(255, 255, 255, 0.3)',
                    borderRadius: '20px',
                    height: '36px',
                    fontSize: '14px',
                    fontWeight: '500',
                    padding: '0 16px'
                  }}
                >
                  Blog
                </Button>
              </div>

              {/* Mobile menu button */}
              <div className="mobile-nav">
                <Button
                  type="text"
                  icon={<MenuOutlined />}
                  onClick={() => setMobileMenuVisible(true)}
                  style={{
                    color: 'white',
                    fontSize: '18px',
                    padding: '0',
                    height: '36px',
                    width: '36px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px', position: 'relative', zIndex: 1 }}>
        
        
        {/* Hero Section */}
        <div style={{ 
          marginBottom: '80px',
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          borderRadius: '20px',
          padding: '60px 40px',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <Row gutter={[48, 32]} align="middle" style={{ position: 'relative', zIndex: 2 }}>
            <Col xs={24} lg={12}>
              <Title level={1} style={{ 
                fontSize: '3.5rem', 
                marginBottom: '20px', 
                color: '#2c3e50',
                fontWeight: '700',
                textAlign: 'center'
              }}>
                Every Child Deserves<br/>Someone Who Understands
              </Title>
              <Paragraph style={{ 
                fontSize: '22px', 
                color: '#7f8c8d', 
                marginBottom: '40px',
                textAlign: 'center'
              }}>
                When children feel overwhelmed, isolated, or struggle with big emotions, 
                Lumi provides the patient, understanding support they need to feel heard and helped.
              </Paragraph>
            </Col>
            <Col xs={24} lg={12} style={{ textAlign: 'center' }}>
              <div style={{
                background: 'rgba(255,255,255,0.9)',
                borderRadius: '20px',
                padding: '40px',
                display: 'inline-block',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
              }}>
                <img 
                  src={meditateCalmiImage} 
                  alt="Child meditating with Lumi companion"
                  style={{ 
                    maxWidth: '300px',
                    width: '100%',
                    height: 'auto',
                    borderRadius: '15px'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentNode.innerHTML = '<div style="font-size: 120px; opacity: 0.8;">🧸</div>';
                  }}
                />
              </div>
            </Col>
          </Row>
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <Button 
              type="primary" 
              size="large"
              style={{
                background: '#e74c3c',
                borderColor: '#e74c3c',
                height: '50px',
                fontSize: '18px',
                fontWeight: 'bold',
                padding: '0 40px',
                marginRight: '16px'
              }}
              onClick={() => {
                document.getElementById('emotional-learning').scrollIntoView({ 
                  behavior: 'smooth' 
                });
              }}
            >
              See How We Help
            </Button>
            <Button 
              size="large"
              style={{
                height: '50px',
                fontSize: '18px',
                padding: '0 40px'
              }}
              onClick={() => history.push('/')}
            >
              Explore Companions
            </Button>
          </div>
        </div>

        {/* Our Mission */}
        <div id="emotional-learning" style={{ marginBottom: '120px' }}>
          <Title level={2} style={{ 
            textAlign: 'center', 
            marginBottom: '24px',
            fontSize: '2.5rem',
            fontWeight: '600',
            color: '#1a1a1a',
            letterSpacing: '-0.01em'
          }}>
            When Your Child Needs Extra Support
          </Title>
          
          {/* Supportive Role Emphasis */}
          <div style={{ 
            padding: '48px', 
            background: 'rgba(102, 126, 234, 0.05)', 
            borderRadius: '24px', 
            marginBottom: '60px',
            border: '1px solid rgba(102, 126, 234, 0.1)',
            display: 'flex',
            alignItems: 'center',
            gap: '40px',
            position: 'relative'
          }}>
            <div style={{ flex: 1, textAlign: 'center', paddingRight: '60px' }}>
            <div style={{ fontSize: '48px', marginBottom: '24px' }}>🤝</div>
            <Title level={3} style={{ 
              color: '#667eea', 
              marginBottom: '20px',
              fontSize: '1.5rem',
              fontWeight: '600'
            }}>
              An Additional Support, Not a Replacement
            </Title>
            <Paragraph style={{ 
              fontSize: '18px', 
              color: '#666', 
              marginBottom: '0',
              lineHeight: '1.6',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              Lumi works <strong>alongside parents and families</strong> to provide consistent emotional support. 
              We're here when your child needs extra help with social challenges, big emotions, or simply when 
              you're busy with work, other children, or life's demands.
            </Paragraph>
            </div>
            
            {/* Floating Lumi - Right aligned */}
            <div style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)' }}>
              <img 
                src={unicornImage} 
                alt="Lumi Unicorn"
                className="floating-calmi"
                style={{ 
                  width: '140px', 
                  height: 'auto',
                  '--rotation': '15deg'
                }}
                onClick={() => history.push('/products/lumi-unicorn')}
              />
            </div>
          </div>

          <Row gutter={[32, 32]}>
            <Col xs={24}>
              <div style={{ padding: '20px' }}>
                <Title level={3}>🌱 Real Help for Real Childhood Challenges</Title>
                <Paragraph style={{ fontSize: '16px', marginBottom: '20px' }}>
                  Whether your child faces social challenges, family changes, or simply needs help 
                  with big emotions, Lumi provides gentle, age-appropriate support:
                </Paragraph>
                
                <Row gutter={[24, 24]}>
                  <Col xs={24} md={12}>
                    <div style={{ padding: '15px', background: '#f0f8ff', borderRadius: '10px' }}>
                      <Title level={4}>😤 When Children Feel Overwhelmed</Title>
                      <ul style={{ fontSize: '15px', marginLeft: '15px' }}>
                        <li>Simple breathing exercises to calm down</li>
                        <li>Help putting big feelings into words</li>
                        <li>Gentle reminders that all feelings are okay</li>
                        <li>Encouragement to talk with trusted adults</li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={24} md={12}>
                    <div style={{ padding: '15px', background: '#f0f8ff', borderRadius: '10px' }}>
                      <Title level={4}>😰 When Children Face Social Challenges</Title>
                      <ul style={{ fontSize: '15px', marginLeft: '15px' }}>
                        <li>Practice conversations for making friends</li>
                        <li>Building confidence for new situations</li>
                        <li>Gentle guidance for handling peer conflicts</li>
                        <li>Support for children who feel left out</li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={24} md={12}>
                    <div style={{ padding: '15px', background: '#f0f8ff', borderRadius: '10px' }}>
                      <Title level={4}>😕 When Families Face Changes</Title>
                      <ul style={{ fontSize: '15px', marginLeft: '15px' }}>
                        <li>Comfort during family transitions</li>
                        <li>Help processing big life changes</li>
                        <li>Consistent support when routines change</li>
                        <li>Reassurance that change is normal</li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={24} md={12}>
                    <div style={{ padding: '15px', background: '#f0f8ff', borderRadius: '10px' }}>
                      <Title level={4}>😔 When Parents Are Busy</Title>
                      <ul style={{ fontSize: '15px', marginLeft: '15px' }}>
                        <li>Emotional support when you're at work</li>
                        <li>Patient listening during homework struggles</li>
                        <li>Bedtime comfort and routine support</li>
                        <li>Gentle reminders of your love and care</li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          
        </div>

        {/* How Our Wellness Framework Works */}
        <div style={{ marginBottom: '120px' }}>
          <Title level={2} style={{ 
            textAlign: 'center', 
            marginBottom: '60px',
            fontSize: '2.5rem',
            fontWeight: '600',
            color: '#1a1a1a',
            letterSpacing: '-0.01em'
          }}>
            Our Wellness Guidance Framework
          </Title>
          
          <div style={{ marginBottom: '60px', padding: '48px', background: 'rgba(82, 196, 26, 0.05)', borderRadius: '24px', border: '1px solid rgba(82, 196, 26, 0.1)', position: 'relative', paddingRight: '200px' }}>
            {/* Floating Lumi - Right aligned */}
            <div style={{ position: 'absolute', right: '20px', top: '20px' }}>
              <img 
                src={squishyBearImage} 
                alt="Lumi Squishy Bear"
                className="floating-calmi"
                style={{ 
                  width: '150px', 
                  height: 'auto',
                  '--rotation': '-20deg'
                }}
                onClick={() => history.push('/products/lumi-squishy-bear')}
              />
            </div>
            <Title level={3} style={{ color: '#52c41a', marginBottom: '24px', fontSize: '1.5rem', fontWeight: '600' }}>🎯 How Lumi Supports Your Child's Emotional Learning:</Title>
            <ul style={{ fontSize: '16px', marginLeft: '20px' }}>
              <li style={{ marginBottom: '12px' }}>
                <strong>Real-Time Emotional Support:</strong> When your child says "I'm really mad," Lumi guides them through counting to 10, taking deep breaths, and identifying what's bothering them—reinforcing techniques you've taught at home
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong>Interactive Breathing Exercises:</strong> Teaches "balloon breathing," "square breathing," and body awareness through gentle, guided practice sessions that children can use anytime they feel overwhelmed
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong>Emotion Vocabulary Building:</strong> Helps children move beyond "good" and "bad" to words like "frustrated," "excited," "nervous," or "proud"—building their emotional intelligence step by step
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong>Coping Strategy Practice:</strong> Teaches self-soothing techniques, positive self-talk, and healthy ways to process big emotions that work alongside your family's values
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong>Social Skills Development:</strong> Guides children through scenarios about friendship, sharing, empathy, and conflict resolution in age-appropriate, gentle ways
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong>Daily Check-In Routines:</strong> Establishes healthy habits of emotional awareness while always encouraging children to share important feelings with their trusted adults
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong>Parent Connection:</strong> Every conversation is shared with parents through the dashboard, ensuring families stay connected and involved in their child's emotional growth
              </li>
            </ul>
          </div>

          <div style={{ padding: '48px', background: 'rgba(255, 193, 7, 0.05)', borderRadius: '24px', border: '1px solid rgba(255, 193, 7, 0.1)' }}>
            <Title level={3} style={{ color: '#faad14', marginBottom: '24px', fontSize: '1.5rem', fontWeight: '600' }}>🚫 What Lumi Will Never Do:</Title>
            <ul style={{ fontSize: '16px', marginLeft: '20px', lineHeight: '1.8' }}>
              <li style={{ marginBottom: '12px' }}>
                <strong>Replace Professional Help:</strong> Always encourages speaking with trusted adults for serious concerns
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong>Provide Medical Advice:</strong> Focuses solely on emotional wellness, not medical guidance
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong>Keep Secrets:</strong> Transparently shares conversations with parents through the dashboard
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong>Create Dependency:</strong> Automatically suggests breaks to prevent over-reliance
              </li>
            </ul>
            <div style={{ textAlign: 'center', marginTop: '32px' }}>
              <Button 
                onClick={() => history.push('/platform')}
                style={{
                  background: '#faad14',
                  borderColor: '#faad14',
                  color: 'white',
                  borderRadius: '50px',
                  height: '48px',
                  fontSize: '16px',
                  fontWeight: '500',
                  paddingLeft: '24px',
                  paddingRight: '24px'
                }}
              >
                How We Keep Kids Safe
              </Button>
            </div>
          </div>
        </div>

        {/* Peace of Mind for Parents */}
        <div style={{ marginBottom: '120px' }}>
          <Title level={2} style={{ 
            textAlign: 'center', 
            marginBottom: '60px',
            fontSize: '2.5rem',
            fontWeight: '600',
            color: '#1a1a1a',
            letterSpacing: '-0.01em'
          }}>
            Peace of Mind for Parents
          </Title>
          <Row gutter={[32, 32]}>
            <Col xs={24} md={8}>
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{ fontSize: '48px', marginBottom: '20px' }}>🤱</div>
                <Title level={4}>When You're Not Available</Title>
                <Paragraph style={{ fontSize: '16px' }}>
                  Lumi provides consistent emotional support during homework struggles, bedtime worries, 
                  or when you're busy with other children. Your child always has a caring companion who 
                  reinforces the values and techniques you've taught.
                </Paragraph>
              </div>
            </Col>
            <Col xs={24} md={8}>
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{ fontSize: '48px', marginBottom: '20px' }}>👨‍👩‍👧‍👦</div>
                <Title level={4}>Family-Centered Approach</Title>
                <Paragraph style={{ fontSize: '16px' }}>
                  Every conversation is transparent and accessible through your parent dashboard. 
                  Lumi encourages children to talk with trusted adults about important feelings 
                  and alerts you when extra support might be needed.
                </Paragraph>
              </div>
            </Col>
            <Col xs={24} md={8}>
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{ fontSize: '48px', marginBottom: '20px' }}>💪</div>
                <Title level={4}>Reinforces Your Parenting</Title>
                <Paragraph style={{ fontSize: '16px' }}>
                  Rather than teaching new concepts, Lumi reinforces the emotional skills and values 
                  you're already instilling. It's like having an extension of your caring guidance 
                  available 24/7.
                </Paragraph>
              </div>
            </Col>
          </Row>
          
          <div style={{ textAlign: 'center', marginTop: '60px', position: 'relative', paddingRight: '160px' }}>
            <Button 
              type="primary"
              size="large"
              onClick={() => history.push('/')}
              style={{
                background: '#667eea',
                borderColor: '#667eea',
                borderRadius: '50px',
                height: '56px',
                fontSize: '16px',
                fontWeight: '500',
                paddingLeft: '32px',
                paddingRight: '32px',
                boxShadow: '0 4px 16px rgba(102, 126, 234, 0.3)'
              }}
            >
              Find the Right Companion
            </Button>
            
            {/* Floating Lumi - Right aligned */}
            <div style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)' }}>
              <img 
                src={lionImage} 
                alt="Lumi Lion"
                className="floating-calmi"
                style={{ 
                  width: '160px', 
                  height: 'auto',
                  '--rotation': '25deg'
                }}
                onClick={() => history.push('/products/lumi-lion')}
              />
            </div>
          </div>
        </div>

        {/* Why Choose Calmi */}
        <div style={{ marginBottom: '120px' }}>
          <Title level={2} style={{ 
            textAlign: 'center', 
            marginBottom: '60px',
            fontSize: '2.5rem',
            fontWeight: '600',
            color: '#1a1a1a',
            letterSpacing: '-0.01em'
          }}>
            Why Choose Lumi for Your Family?
          </Title>
          <div style={{ position: 'relative', paddingRight: '180px', marginBottom: '30px' }}>
            {/* Floating Lumi - Right aligned */}
            <div style={{ position: 'absolute', right: '20px', top: '60px' }}>
              <img 
                src={squishyUnicornImage} 
                alt="Lumi Squishy Unicorn"
                className="floating-calmi"
                style={{ 
                  width: '140px', 
                  height: 'auto',
                  '--rotation': '-15deg'
                }}
                onClick={() => history.push('/products/lumi-squishy-unicorn')}
              />
            </div>
            
            <Row gutter={[48, 48]}>
            <Col xs={24} md={8}>
              <div style={{ textAlign: 'center', padding: '32px 24px', height: '100%' }}>
                <HeartOutlined style={{ fontSize: '64px', color: '#667eea', marginBottom: '24px' }} />
                <Title level={4} style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '16px' }}>Evidence-Based Wellness</Title>
                <Text style={{ fontSize: '16px', lineHeight: '1.6', color: '#666' }}>
                  Built on proven child development research, wellness practices, and gentle support techniques 
                  that encourage healthy emotional growth—all designed to work alongside your parenting.
                </Text>
              </div>
            </Col>
            <Col xs={24} md={8}>
              <div style={{ textAlign: 'center', padding: '32px 24px', height: '100%' }}>
                <SafetyOutlined style={{ fontSize: '64px', color: '#764ba2', marginBottom: '24px' }} />
                <Title level={4} style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '16px' }}>Complete Transparency</Title>
                <Text style={{ fontSize: '16px', lineHeight: '1.6', color: '#666' }}>
                  Every conversation is available to parents through detailed dashboard reports. 
                  No secrets, no surprises—just consistent support that keeps families connected.
                </Text>
              </div>
            </Col>
            <Col xs={24} md={8}>
              <div style={{ textAlign: 'center', padding: '32px 24px', height: '100%' }}>
                <BulbOutlined style={{ fontSize: '64px', color: '#52c41a', marginBottom: '24px' }} />
                <Title level={4} style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '16px' }}>Skills That Last</Title>
                <Text style={{ fontSize: '16px', lineHeight: '1.6', color: '#666' }}>
                  Teaches practical emotional regulation skills, healthy coping mechanisms, and self-awareness 
                  that children will use throughout their lives—starting with what you've already begun.
                </Text>
              </div>
            </Col>
            </Row>
          </div>
        </div>

        {/* Navigation to other pages */}
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <Title level={3} style={{ marginBottom: '30px' }}>Explore More</Title>
          <Row gutter={[16, 16]} justify="center">
            <Col>
              <Button 
                type="primary" 
                size="large"
                onClick={() => history.push('/')}
                style={{
                  background: '#e74c3c',
                  borderColor: '#e74c3c',
                  height: '50px',
                  fontSize: '16px',
                  padding: '0 30px'
                }}
              >
                Find Your Companion
              </Button>
            </Col>
            <Col>
              <Button 
                size="large"
                onClick={() => history.push('/platform')}
                style={{
                  height: '50px',
                  fontSize: '16px',
                  padding: '0 30px'
                }}
              >
                Safety
              </Button>
            </Col>
          </Row>
        </div>
      </div>

      {/* Mobile Menu Drawer */}
      <Drawer
        title="Menu"
        placement="right"
        onClose={() => setMobileMenuVisible(false)}
        open={mobileMenuVisible}
        width={280}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Button
            type="text"
            onClick={() => {
              history.push('/');
              setMobileMenuVisible(false);
            }}
            style={{
              textAlign: 'left',
              fontSize: '16px',
              height: '48px',
              justifyContent: 'flex-start'
            }}
          >
            🧸 Find Your Companion
          </Button>
          <Button
            type="text"
            onClick={() => {
              history.push('/platform');
              setMobileMenuVisible(false);
            }}
            style={{
              textAlign: 'left',
              fontSize: '16px',
              height: '48px',
              justifyContent: 'flex-start'
            }}
          >
            🛡️ Safety
          </Button>
          <Button
            type="text"
            onClick={() => {
              history.push('/blog');
              setMobileMenuVisible(false);
            }}
            style={{
              textAlign: 'left',
              fontSize: '16px',
              height: '48px',
              justifyContent: 'flex-start'
            }}
          >
            📚 Blog
          </Button>
        </div>
      </Drawer>
    </div>
  );
};

export default CalmiWellness;